import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";

export function Gdpr() {
    const [isShown, setIsShown] = useState(false);
    const location = useLocation();
    const closeNotice = () => {
        setIsShown(false);
        localStorage.setItem('mn-gdpr', 'accepted');
    }
    useEffect(() => {
        var _gdpr = localStorage.getItem('mn-gdpr');
        if (_gdpr) {
            if (_gdpr === 'accepted' || location.pathname.includes('/privacy')) setIsShown(false);
            else showGdpr();
        } else {
            if (location.pathname.includes('/privacy')) setIsShown(false);
            else showGdpr();
        }
    }, [setIsShown, location.pathname]);
    const showGdpr = () => setTimeout(() => {
        setIsShown(true);
    }, 5000);

    return (
        <>
            <div className={"gdpr" + (isShown ? " show" : "")}>
                <span onClick={() => closeNotice()}><i className="icon-times"></i></span>
                <p>This site uses cookies to ensure you get the best experience. It's assumed that you're okay with this if you continue browsing. <a href="/privacy" target="_blank" rel="noreferrer">Privacy policy</a></p>
            </div>
        </>
    );
}
